import { computed } from 'vue';

import { storeToRefs } from 'pinia';

import { useCatalogFiltersStore } from '../stores/catalogFilters';

const useCatalogFilters = () => {
  const filterStore = useCatalogFiltersStore();
  const {
    getFacets,
    getCurrentFilters,
    getCurrentTags,
    getOptionCards,
    getCardSelected,
    getResults,
    getPageInfo,
    getLoading,
    getCurrentOrder,
    getAllResultsCount,
    getModalReservationFlag,
    getModalPreviewFlag,
    getActivityPreview,
    getCatalogCodeComponent,
    getCatalogModalComponent,
    getTitleDate,
    getFormattedDate,
    getSelectedSchedule,
    getAllTimeRanges,
    getOrderType,
    getKeywords,
  } = storeToRefs(filterStore);

  const init = async (initialKeywords = null) => {
    await filterStore.init(initialKeywords);
  };

  const handleChangeFilters = async (key, type) => {
    await filterStore.handleChangeFilters(key, type);
  };

  const updateFilters = async (updates) => {
    await filterStore.updateFilters(updates);
  };

  const getDataFromFilters = async () => {
    const res = await filterStore.getDataFromFilters();
    return res;
  };

  const getTravel = async () => {
    const res = await filterStore.getDataFromFilters();
    return res;
  };

  const getBoxes = async () => {
    const res = await filterStore.getDataFromFilters();
    return res;
  };

  const getActivities = async () => {
    const res = await filterStore.getDataFromFilters();
    return res;
  };

  const clearCurrentFilters = async (options = {}) => {
    await filterStore.clearCurrentFilters(options);
  };

  const setCard = (cardId, fireSearch = true) => {
    filterStore.setCard(cardId);
    if (fireSearch) {
      filterStore.getDataFromFilters();
    }
  };

  const setBoxCategory = category => {
    filterStore.setBoxCategory(category);
  };

  const deleteTags = ({ key, inputType, value }) => {
    filterStore.removeTag({ key, inputType, value });
  };

  const setKeywords = (keywords, shouldFetch = true, shouldUpdateURL = true) => {
    filterStore.setKeywords(keywords, shouldFetch, shouldUpdateURL);
  };

  const resetPaginationNumber = () => {
    filterStore.resetPaginationNumber();
  };

  const setBoxId = (boxId, shouldFetch = true, shouldUpdateURL = true) => {
    filterStore.setBoxId(boxId, shouldFetch, shouldUpdateURL);
  };

  const onToggleModalPreview = activityObject => {
    filterStore.onToggleModalPreview(activityObject);
  };

  const onToggleModalReservation = () => {
    filterStore.onToggleModalReservation();
  };

  const onActivityBySlug = async slug => {
    await filterStore.onActivityBySlug(slug);
  };

  const onSetTimeSlot = (timeSlot, shouldFetch = true) => {
    filterStore.onSetTimeSlot(timeSlot, shouldFetch);
  };

  const onSetDate = (date, shouldFetch = true) => {
    filterStore.onSetDate(date, shouldFetch);
  };

  const onSetSchedule = schedule => {
    filterStore.onSetSchedule(schedule);
  };

  const cleanAvailability = () => {
    filterStore.cleanAvailability();
  };

  const fetchTimeRanges = async () => {
    await filterStore.getTimeRanges();
  };

  const scrollToResultsStart = () => {
    const activitiesResultElement = document.getElementById(
      'catalogviewResultsContainer',
    );
    if (activitiesResultElement) {
      activitiesResultElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  const updatePageNumber = pageNumber => {
    filterStore.updatePageNumber(pageNumber);
  };

  const applyURLFilters = urlFilters => {
    filterStore.applyURLFilters(urlFilters);
  };

  const setCatalogOrderType = orderType => {
    filterStore.setCatalogOrderType(orderType);
  };

  const registerURLUpdateCallback = callback => {
    filterStore.registerURLUpdateCallback(callback);
  };

  const unregisterURLUpdateCallback = () => {
    filterStore.unregisterURLUpdateCallback();
  };

  const cancelAllRequests = () => {
    filterStore.cancelAllRequests();
  };

  return {
    init,
    handleChangeFilters,
    updateFilters,
    getDataFromFilters,
    getTravel,
    getBoxes,
    getActivities,
    clearCurrentFilters,
    setCard,
    setBoxCategory,
    setKeywords,
    setBoxId,
    deleteTags,
    resetPaginationNumber,
    applyURLFilters,
    registerURLUpdateCallback,
    unregisterURLUpdateCallback,
    cancelAllRequests,
    onToggleModalPreview,
    onToggleModalReservation,
    onActivityBySlug,
    onSetTimeSlot,
    onSetDate,
    onSetSchedule,
    cleanAvailability,
    fetchTimeRanges,
    scrollToResultsStart,
    updatePageNumber,
    setCatalogOrderType,
    getPageInfo: computed(() => getPageInfo.value),
    getFacets: computed(() => getFacets.value),
    getCurrentFilters: computed(() => getCurrentFilters.value),
    getCurrentTags: computed(() => getCurrentTags.value),
    getOptionCards: computed(() => getOptionCards.value),
    getCardSelected: computed(() => getCardSelected.value),
    getResults: computed(() => getResults.value),
    getLoading: computed(() => getLoading.value),
    getCurrentOrder: computed(() => getCurrentOrder.value),
    getAllResultsCount: computed(() => getAllResultsCount.value),
    getModalPreviewFlag: computed(() => getModalPreviewFlag.value),
    getModalReservationFlag: computed(() => getModalReservationFlag.value),
    getActivityPreview: computed(() => getActivityPreview.value),
    getCatalogCodeComponent: computed(() => getCatalogCodeComponent.value),
    getCatalogModalComponent: computed(() => getCatalogModalComponent.value),
    getTitleDate: computed(() => getTitleDate.value),
    getFormattedDate: computed(() => getFormattedDate.value),
    getSelectedSchedule: computed(() => getSelectedSchedule.value),
    getAllTimeRanges: computed(() => getAllTimeRanges.value),
    getOrderType: computed(() => getOrderType.value),
    getKeywords: computed(() => getKeywords.value),
  };
};

export default useCatalogFilters;
